import {
    BY_CREATION_TIME_NEWEST,
    BY_CREATION_TIME_OLDEST,
    BY_NEW_MESSAGES,
    BY_PRICE_ASC,
    BY_PRICE_DESC,
    BY_REPOST_TIME_NEWEST,
    BY_REPOST_TIME_OLDEST,
    BY_TITLE,
    BY_TITLE_REVERSED,
    BZ2_CAT_ADULT_FANCY_DRESS,
    BZ2_CAT_ADULTS_AUDIO,
    BZ2_CAT_ADULTS_BAGS_BETLS_WALLETS,
    BZ2_CAT_ADULTS_BLOUSE_SHIRTS,
    BZ2_CAT_ADULTS_BOOKS,
    BZ2_CAT_ADULTS_BOOKS_AUDIO_VIDEO,
    BZ2_CAT_ADULTS_BOOKS_MAGAZINES_AUDIO_VIDEO,
    BZ2_CAT_ADULTS_CLOTHING_MEGAPACKS,
    BZ2_CAT_ADULTS_COATS,
    BZ2_CAT_ADULTS_DRESSES,
    BZ2_CAT_ADULTS_FANCY_DRESS,
    BZ2_CAT_ADULTS_FOOTWEAR,
    BZ2_CAT_ADULTS_HANDICRAFTS,
    BZ2_CAT_ADULTS_HATS_GLOVES,
    BZ2_CAT_ADULTS_HEALTH_BEAUTY,
    BZ2_CAT_ADULTS_HOMEWARE,
    BZ2_CAT_ADULTS_JACKETS,
    BZ2_CAT_ADULTS_JEWELLERY,
    BZ2_CAT_ADULTS_MAGAZINES,
    BZ2_CAT_ADULTS_MISC,
    BZ2_CAT_ADULTS_MULTIMEDIA,
    BZ2_CAT_ADULTS_OUTFITS,
    BZ2_CAT_ADULTS_SHORTS,
    BZ2_CAT_ADULTS_SKIRTS,
    BZ2_CAT_ADULTS_SLEEPWEAR,
    BZ2_CAT_ADULTS_SOCKS_TIGHTS,
    BZ2_CAT_ADULTS_SPORT,
    BZ2_CAT_ADULTS_SPORT_CLOTHING,
    BZ2_CAT_ADULTS_SUITS,
    BZ2_CAT_ADULTS_SWEATSHIRTS_KNITWEAR,
    BZ2_CAT_ADULTS_SWIMWEAR,
    BZ2_CAT_ADULTS_TRAUSERS_JEANS,
    BZ2_CAT_ADULTS_TSHIRTS_TOPS,
    BZ2_CAT_ADULTS_UNDERWEAR,
    BZ2_CAT_ADULTS_VIDEO,
    BZ2_CAT_BABY_ACCESSORIES,
    BZ2_CAT_BABY_CARRIERS,
    BZ2_CAT_BABY_FEEDING,
    BZ2_CAT_BABY_MISC,
    BZ2_CAT_BIRTH,
    BZ2_CAT_BLANKETS_WRAPPERS,
    BZ2_CAT_BLOUSE_SHIRTS,
    BZ2_CAT_BODYSUITS_SLEEPSUITS_ROMPERS,
    BZ2_CAT_BOOKS_AUDIO_VIDEO,
    BZ2_CAT_BOUNCERS,
    BZ2_CAT_BREASTFEEDING_ACCESSORIES,
    BZ2_CAT_CAMERA_PHOTO_VIDEO,
    BZ2_CAT_CAR_SEATS,
    BZ2_CAT_CELEBRATIONS,
    BZ2_CAT_CHILDREN_AUDIO,
    BZ2_CAT_CHILDREN_BOOKS,
    BZ2_CAT_CHILDREN_CARE,
    BZ2_CAT_CHILDREN_CLOTHING,
    BZ2_CAT_CHILDREN_MAGAZINES,
    BZ2_CAT_CHILDREN_MULTIMEDIA,
    BZ2_CAT_CHILDREN_VIDEO,
    BZ2_CAT_CHRISTMAS,
    BZ2_CAT_CLOTHING_MEGAPACKS,
    BZ2_CAT_COSMETICS_BATHING,
    BZ2_CAT_COTS,
    BZ2_CAT_DINING,
    BZ2_CAT_DRESSES_SKIRTS,
    BZ2_CAT_EARLY_BABIES,
    BZ2_CAT_EASTER,
    BZ2_CAT_ELECTRONICS,
    BZ2_CAT_FACE_PAINTING,
    BZ2_CAT_FANCY_DRESS,
    BZ2_CAT_FANCY_DRESS_ACCESSORIES,
    BZ2_CAT_FOOD,
    BZ2_CAT_FOOTWEAR,
    BZ2_CAT_GIFTS,
    BZ2_CAT_HATS_MITTENS_SCARVES,
    BZ2_CAT_HOME_ACCESSORIES_DECORATIONS,
    BZ2_CAT_HOME_ANTIQUITIES,
    BZ2_CAT_HOME_APPLIANCES,
    BZ2_CAT_HOME_CARE_CLEANING,
    BZ2_CAT_HOME_CARPETS_RUGS,
    BZ2_CAT_HOME_COOKING_BAKING_WARE,
    BZ2_CAT_HOME_DINING,
    BZ2_CAT_HOME_FOOD_STORAGE,
    BZ2_CAT_HOME_FURNITURE,
    BZ2_CAT_HOME_LIGHTING,
    BZ2_CAT_HOME_LIVING,
    BZ2_CAT_HOME_TEXTILES,
    BZ2_CAT_JACKETS_COATS,
    BZ2_CAT_KIDS_PARTY,
    BZ2_CAT_KINDERGARDEN_SCHOOL,
    BZ2_CAT_MISC,
    BZ2_CAT_MISC_MOTHERHOOD,
    BZ2_CAT_MOTHER_CLOTHING,
    BZ2_CAT_MOTHERS_NOURISHMENT,
    BZ2_CAT_NAPPIES,
    BZ2_CAT_NOURISHMENT,
    BZ2_CAT_NURSERY,
    BZ2_CAT_NURSING_BRA,
    BZ2_CAT_OCCASION_WEAR,
    BZ2_CAT_OTHER_ELECTRONICS,
    BZ2_CAT_OUTFITS,
    BZ2_CAT_PARTY_CARNEVAL,
    BZ2_CAT_PC_GAMING,
    BZ2_CAT_PC_NOTEBOOKS,
    BZ2_CAT_PETS,
    BZ2_CAT_PHONES_TABLETS_EREADERS,
    BZ2_CAT_PRAMS,
    BZ2_CAT_PREGNANCY_CLOTHING,
    BZ2_CAT_PREGNANCY_MOTHERS,
    BZ2_CAT_SAFETY,
    BZ2_CAT_SEO_BABY_ACCESSORIES,
    BZ2_CAT_SEO_BLOUSE_SHIRTS,
    BZ2_CAT_SEO_BODYSUITS_SLEEPSUITS_ROMPERS,
    BZ2_CAT_SEO_CLOTHING_MEGAPACKS,
    BZ2_CAT_SEO_DRESSES_SKIRTS,
    BZ2_CAT_SEO_HATS_MITTENS_SCARVES,
    BZ2_CAT_SEO_JACKETS_COATS,
    BZ2_CAT_SEO_OCCASION_WEAR,
    BZ2_CAT_SEO_OUTFITS,
    BZ2_CAT_SEO_SHORTS_CROPS,
    BZ2_CAT_SEO_SLEEPING_BAGS,
    BZ2_CAT_SEO_SLEEPWEAR,
    BZ2_CAT_SEO_SNOWSUITS,
    BZ2_CAT_SEO_SOCKS_TIGHTS,
    BZ2_CAT_SEO_SWEATSHIRTS_JUMPERS_VESTS,
    BZ2_CAT_SEO_SWIMWEAR_DRESSING_GOWNS,
    BZ2_CAT_SEO_TROUSERS_JEANS_JOGGERS,
    BZ2_CAT_SEO_TSHIRTS_TOPS,
    BZ2_CAT_SEO_TWINS,
    BZ2_CAT_SEO_TWINS_MISC,
    BZ2_CAT_SEO_UNDERWEAR,
    BZ2_CAT_SHORTS_CROPS,
    BZ2_CAT_SLEEPING_BAGS,
    BZ2_CAT_SLEEPWEAR,
    BZ2_CAT_SNOWSUITS,
    BZ2_CAT_SOCKS_TIGHTS,
    BZ2_CAT_SPORT,
    BZ2_CAT_SWEATSHIRTS_JUMPERS_VESTS,
    BZ2_CAT_SWIMWEAR_DRESSING_GOWNS,
    BZ2_CAT_TOYS,
    BZ2_CAT_TROUSERS_JEANS_JOGGERS,
    BZ2_CAT_TSHIRTS_TOPS,
    BZ2_CAT_TWINS,
    BZ2_CAT_TWINS_GROUP,
    BZ2_CAT_TWINS_MISC,
    BZ2_CAT_UNDERWEAR,
    BZ2_CAT_WALKERS,
    BZ2_FACET_CATEGORY,
    BZ2_FACET_CATS,
    BZ2_FACET_GROUPS,
    BZ2_FACET_LOCATIONS,
    BZ2_FACET_P_AGE_GROUP,
    BZ2_FACET_P_AGE_MONTHS,
    BZ2_FACET_P_AGE_YEARS,
    BZ2_FACET_P_ANIMAL,
    BZ2_FACET_P_BRACES,
    BZ2_FACET_P_BRAND,
    BZ2_FACET_P_COLOR,
    BZ2_FACET_P_CUP_SIZE,
    BZ2_FACET_P_DATA_CARRIER,
    BZ2_FACET_P_GAMING_PLATFORM,
    BZ2_FACET_P_LANGUAGE,
    BZ2_FACET_P_LENGTH,
    BZ2_FACET_P_LENGTH_ORDINAL,
    BZ2_FACET_P_MATERIAL,
    BZ2_FACET_P_NECKLINE,
    BZ2_FACET_P_OCCASION,
    BZ2_FACET_P_PRICE,
    BZ2_FACET_P_QUALITY,
    BZ2_FACET_P_SCREEN_SIZE,
    BZ2_FACET_P_SEASON,
    BZ2_FACET_P_SEX,
    BZ2_FACET_P_SEX_TWIN,
    BZ2_FACET_P_SHAPE,
    BZ2_FACET_P_SIZE,
    BZ2_FACET_P_SIZE_INTERVAL,
    BZ2_FACET_P_SIZE_WEIGHT,
    BZ2_FACET_P_SLEEVE,
    BZ2_FACET_P_STYLE,
    BZ2_FACET_P_SUBJECT,
    BZ2_FACET_P_THEMA,
    BZ2_FACET_P_TYPE,
    BZ2_FACET_P_USAGE,
    BZ2_FACET_P_WIDTH_ORDINAL,
    BZ2_FACET_QUALITY,
    BZ2_FACET_SCREEN_SIZE,
    BZ2_HANDMADE_PRODUCT_HOVER,
    BZ2_NEW_PRODUCT_HOVER,
    BZ2_OLD_PRODUCT_HOVER,
    BZ2_SORT_COMPLAINT_TIME,
    BZ2_SORT_COMPLAINT_TIME_ASC,
    BZ2_SORT_COMPLAINTS,
    BZ2_SORT_COMPLAINTS_ASC,
    BZ2_SORT_LEAST_RECENT_ADDED,
    BZ2_SORT_LEAST_RECENT_UPDATED,
    BZ2_SORT_PRICE,
    BZ2_SORT_PRICE_DESC,
    BZ2_SORT_RECENT_ADDED,
    BZ2_SORT_RECENT_UPDATED,
    BZ2_SORT_SCORE_NEW,
    BZ2_SORT_WISHLIST_ADDED_ASC,
    BZ2_SORT_WISHLIST_ADDED_DESC,
    PRODUCT_FILTER_ACTUALIZABLE,
    PRODUCT_FILTER_ALL,
    PRODUCT_FILTER_DELETED,
    PRODUCT_FILTER_DISPLAYING,
    PRODUCT_FILTER_EXPIRED,
    PRODUCT_FILTER_NONDISPLAYING,
    PRODUCT_FILTER_NOTANSWERED,
} from 'mk/autogenerated/translations/enums.529348059c865ac48d46749de662f6ae'
import { simpleEnum } from 'mk/common/utils';

export const REVIEW_RATING = {
    UNSATISFIED: -1,
    SATISFIED: 1,
    VERY_SATISFIED: 2,
};

// order of this is kinda important as this goes directly to the selector widget
// and it renders the options by order they are in this map (js does not have
// guaranteed map order but seems consistent in all implementations)
export const SORTING_VALUES = {
    update: BZ2_SORT_RECENT_UPDATED,
    update_asc: BZ2_SORT_LEAST_RECENT_UPDATED,
    creation: BZ2_SORT_RECENT_ADDED,
    creation_asc: BZ2_SORT_LEAST_RECENT_ADDED,
    price: BZ2_SORT_PRICE,
    price_desc: BZ2_SORT_PRICE_DESC,
    score_new: BZ2_SORT_SCORE_NEW,
    complaints: BZ2_SORT_COMPLAINTS,
    complaints_asc: BZ2_SORT_COMPLAINTS_ASC,
    complaint_time: BZ2_SORT_COMPLAINT_TIME,
    complaint_time_asc: BZ2_SORT_COMPLAINT_TIME_ASC,
};

export const WISHLIST_SORTING_VALUES = {
    wishlist: BZ2_SORT_WISHLIST_ADDED_DESC,
    wishlist_asc: BZ2_SORT_WISHLIST_ADDED_ASC,
};

// keep in sync with python code in bazaar.api.v2.utils.filter.MY_BAZAAR_ORDER_BY
export const MY_SORTING_VALUES = {
    new_messages: BY_NEW_MESSAGES,
    title: BY_TITLE,
    title_reversed: BY_TITLE_REVERSED,
    updated_latest: BY_REPOST_TIME_NEWEST,
    updated_oldest: BY_REPOST_TIME_OLDEST,
    created_newest: BY_CREATION_TIME_NEWEST,
    created_oldest: BY_CREATION_TIME_OLDEST,
    price_asc: BY_PRICE_ASC,
    price_desc: BY_PRICE_DESC,
};

export const MY_FILTER_VALUES = {
    all: PRODUCT_FILTER_ALL,
    actualizable: PRODUCT_FILTER_ACTUALIZABLE,
    displaying: PRODUCT_FILTER_DISPLAYING,
    nondisplaying: PRODUCT_FILTER_NONDISPLAYING,
    expired: PRODUCT_FILTER_EXPIRED,
    deleted: PRODUCT_FILTER_DELETED,
    notanswered: PRODUCT_FILTER_NOTANSWERED,
};

export const QUALITY_VALUES = {
    old: {
        label: BZ2_OLD_PRODUCT_HOVER,
        max: -1,
        max_plus: -1,
        max_pro: -1,
    },
    new: {
        label: BZ2_NEW_PRODUCT_HOVER,
        max: 10,
        max_plus: 10,
        max_pro: -1,
    },
    handmade: {
        label: BZ2_HANDMADE_PRODUCT_HOVER,
        max: 50,
        max_plus: 50,
        max_pro: -1,
    },
};

export const PLANS = {
    PLAN_FREE: 'free',
    PLAN_FREE_REPOST: 'free.repost',
    PLAN_PLUS: 'plus',
    PLAN_PLUS_REPOST: 'plus.repost',
    PLAN_PRO: 'pro',
};

// let COUNTY_SK = {
//    1:'Bánovce nad Bebravou',
//    2:'Banská Bystrica',
//    3:'Banská Štiavnica',
//    4:'Bardejov',
//    5:'Bratislava',
//    6:'Brezno',
//    7:'Bytča',
//    8:'Čadca',
//    9:'Detva',
//    10:'Dolný Kubín',
//    11:'Dunajská Streda',
//    12:'Galanta',
//    13:'Gelnica',
//    14:'Hlohovec',
//    15:'Humenné',
//    16:'Ilava',
//    17:'Kežmarok',
//    18:'Komárno',
//    19:'Košice',
//    20:'Košice-okolie',
//    21:'Krupina',
//    22:'Kysucké Nové Mesto',
//    23:'Levice',
//    24:'Levoča',
//    25:'Liptovský Mikuláš',
//    26:'Lučenec',
//    27:'Malacky',
//    28:'Martin',
//    29:'Medzilaborce',
//    30:'Michalovce',
//    31:'Myjava',
//    32:'Námestovo',
//    33:'Nitra',
//    34:'Nové Mesto nad Váhom',
//    35:'Nové Zámky',
//    36:'Partizánske',
//    37:'Pezinok',
//    38:'Piešťany',
//    39:'Poltár',
//    40:'Poprad',
//    41:'Považská Bystrica',
//    42:'Prešov',
//    43:'Prievidza',
//    44:'Revúca',
//    45:'Rimavská Sobota',
//    46:'Rožňava',
//    47:'Ružomberok',
//    48:'Sabinov',
//    49:'Senec',
//    50:'Senica',
//    51:'Skalica',
//    52:'Snina',
//    53:'Sobrance',
//    54:'Spišská Nová Ves',
//    55:'Stará Ľubovňa',
//    56:'Stropkov',
//    57:'Svidník',
//    58:'Šaľa',
//    59:'Topoľčany',
//    60:'Trebišov',
//    61:'Trenčín',
//    62:'Trnava',
//    63:'Turčianske Teplice',
//    64:'Tvrdošín',
//    65:'Veľký Krtíš',
//    66:'Vranov nad Topľou',
//    67:'Zlaté Moravce',
//    68:'Zvolen',
//    69:'Žarnovica',
//    70:'Žiar nad Hronom',
//    71:'Žilina',
//    72:'Púchov'
// };

// bazaar/models/Product
export const PRODUCT_STATUS = {
    STATUS_ACTIVE: 0,
    STATUS_INACTIVE: 1,
    STATUS_BLOCKED: 2,
    STATUS_EXPIRED: 3,
    STATUS_DELETED: 4,
};

export const PRODUCT_DELETED_REASONS = {
    DELETED_REASON_COPYRIGHT_PHOTOS: 1,
    DELETED_REASON_WRONG_PRICE: 2,
    DELETED_REASON_INVISIBLE_PRODUCT: 3,
    DELETED_REASON_DONT_KNOW_WHAT_SELLING: 4,
    DELETED_REASON_NOT_FOR_TWINS: 5,
    DELETED_REASON_NOT_ALLOWED: 6,
    DELETED_REASON_MULTIPLE_PRODUCTS: 7,
    DELETED_REASON_SERVICE: 8,
    DELETED_REASON_LANGUAGE: 9,
    DELETED_REASON_NOT_ALLOWED_DUPLICATE: 10,
    DELETED_REASON_NOT_ALLOWED_DRUGS: 11,
    DELETED_REASON_NOT_ALLOWED_OPEN: 12,
    DELETED_REASON_NOT_ALLOWED_ANNOUNCEMENT: 13,
    DELETED_REASON_NOT_ALLOWED_INQUIRY: 14,
    DELETED_REASON_NOT_ALLOWED_CONTEXT: 15,
};

// keep in sync with py code in enums.py/REPOSTABLE
export const REPOSTABLE_STATUS = simpleEnum([
    'created_recently',         // just created - minutes
    'reposted_recently',        // just reposted -minutes
    'not_repostable',           // already active, hidden, deleted category...etc
    'repostable_free',           // free to repost
    'repostable_paid',           // aready reposted - have wait some time (1-7 days)
    'repostable_enter_facets',   // listing has to be modified - missing facets, etc
    'repostable_not_available',  // reposts over limit - cannot repost anymore fornow
    'reposting',                 // reposting request pending
    'reposting_failed',          // other error of reposting
]);

export const ERROR_CODES = simpleEnum([
    'CSRF_CHANGED_ERROR',
]);

// index within categories where adults cats starts
export const ADULT_INDEX = 15;

// keep in sync with Product stock statuses in bazaar/models.py
export const STOCK_STATUS = {
    NOT_IN_STOCK: 0,
    IN_STOCK: 1,
};

export const FACET_NAMES = {
    BZ2_FACET_CATEGORY,
    BZ2_FACET_CATS,
    BZ2_FACET_GROUPS,
    BZ2_FACET_LOCATIONS,
    BZ2_FACET_P_AGE_GROUP,
    BZ2_FACET_P_AGE_MONTHS,
    BZ2_FACET_P_AGE_YEARS,
    BZ2_FACET_P_ANIMAL,
    BZ2_FACET_P_BRACES,
    BZ2_FACET_P_BRAND,
    BZ2_FACET_P_COLOR,
    BZ2_FACET_P_CUP_SIZE,
    BZ2_FACET_P_DATA_CARRIER,
    BZ2_FACET_P_GAMING_PLATFORM,
    BZ2_FACET_P_LANGUAGE,
    BZ2_FACET_P_LENGTH,
    BZ2_FACET_P_LENGTH_ORDINAL,
    BZ2_FACET_P_MATERIAL,
    BZ2_FACET_P_NECKLINE,
    BZ2_FACET_P_OCCASION,
    BZ2_FACET_P_PRICE,
    BZ2_FACET_P_QUALITY,
    BZ2_FACET_P_SCREEN_SIZE,
    BZ2_FACET_P_SEASON,
    BZ2_FACET_P_SEX,
    BZ2_FACET_P_SEX_TWIN,
    BZ2_FACET_P_SHAPE,
    BZ2_FACET_P_SIZE,
    BZ2_FACET_P_SIZE_INTERVAL,
    BZ2_FACET_P_SIZE_WEIGHT,
    BZ2_FACET_P_SLEEVE,
    BZ2_FACET_P_STYLE,
    BZ2_FACET_P_SUBJECT,
    BZ2_FACET_P_THEMA,
    BZ2_FACET_P_TYPE,
    BZ2_FACET_P_USAGE,
    BZ2_FACET_P_WIDTH_ORDINAL,
    BZ2_FACET_QUALITY,
    BZ2_FACET_SCREEN_SIZE,
};

export const CATEGORY_SEO_NAMES = {
    BZ2_CAT_SEO_UNDERWEAR,
    BZ2_CAT_SEO_BLOUSE_SHIRTS,
    BZ2_CAT_SEO_SWEATSHIRTS_JUMPERS_VESTS,
    BZ2_CAT_SEO_SLEEPING_BAGS,
    BZ2_CAT_SEO_SWIMWEAR_DRESSING_GOWNS,
    BZ2_CAT_SEO_DRESSES_SKIRTS,
    BZ2_CAT_SEO_JACKETS_COATS,
    BZ2_CAT_SEO_CLOTHING_MEGAPACKS,
    BZ2_CAT_SEO_SOCKS_TIGHTS,
    BZ2_CAT_SEO_TROUSERS_JEANS_JOGGERS,
    BZ2_CAT_SEO_SNOWSUITS,
    BZ2_CAT_SEO_BABY_ACCESSORIES,
    BZ2_CAT_SEO_BODYSUITS_SLEEPSUITS_ROMPERS,
    BZ2_CAT_SEO_SHORTS_CROPS,
    BZ2_CAT_SEO_HATS_MITTENS_SCARVES,
    BZ2_CAT_SEO_TSHIRTS_TOPS,
    BZ2_CAT_SEO_OUTFITS,
    BZ2_CAT_SEO_SLEEPWEAR,
    BZ2_CAT_SEO_OCCASION_WEAR,
    BZ2_CAT_SEO_TWINS,
    BZ2_CAT_SEO_TWINS_MISC,
};

export const CATEGORY_NAMES = {
    BZ2_CAT_ADULT_FANCY_DRESS,
    BZ2_CAT_ADULTS_AUDIO,
    BZ2_CAT_ADULTS_BAGS_BETLS_WALLETS,
    BZ2_CAT_ADULTS_BLOUSE_SHIRTS,
    BZ2_CAT_ADULTS_BOOKS,
    BZ2_CAT_ADULTS_BOOKS_AUDIO_VIDEO,
    BZ2_CAT_ADULTS_BOOKS_MAGAZINES_AUDIO_VIDEO,
    BZ2_CAT_ADULTS_CLOTHING_MEGAPACKS,
    BZ2_CAT_ADULTS_COATS,
    BZ2_CAT_ADULTS_DRESSES,
    BZ2_CAT_ADULTS_FANCY_DRESS,
    BZ2_CAT_ADULTS_FOOTWEAR,
    BZ2_CAT_ADULTS_HANDICRAFTS,
    BZ2_CAT_ADULTS_HATS_GLOVES,
    BZ2_CAT_ADULTS_HEALTH_BEAUTY,
    BZ2_CAT_ADULTS_HOMEWARE,
    BZ2_CAT_ADULTS_JACKETS,
    BZ2_CAT_ADULTS_JEWELLERY,
    BZ2_CAT_ADULTS_MAGAZINES,
    BZ2_CAT_ADULTS_MISC,
    BZ2_CAT_ADULTS_MULTIMEDIA,
    BZ2_CAT_ADULTS_OUTFITS,
    BZ2_CAT_ADULTS_SHORTS,
    BZ2_CAT_ADULTS_SKIRTS,
    BZ2_CAT_ADULTS_SLEEPWEAR,
    BZ2_CAT_ADULTS_SOCKS_TIGHTS,
    BZ2_CAT_ADULTS_SPORT,
    BZ2_CAT_ADULTS_SPORT_CLOTHING,
    BZ2_CAT_ADULTS_SUITS,
    BZ2_CAT_ADULTS_SWEATSHIRTS_KNITWEAR,
    BZ2_CAT_ADULTS_SWIMWEAR,
    BZ2_CAT_ADULTS_TRAUSERS_JEANS,
    BZ2_CAT_ADULTS_TSHIRTS_TOPS,
    BZ2_CAT_ADULTS_UNDERWEAR,
    BZ2_CAT_ADULTS_VIDEO,
    BZ2_CAT_BABY_ACCESSORIES,
    BZ2_CAT_BABY_CARRIERS,
    BZ2_CAT_BABY_FEEDING,
    BZ2_CAT_BABY_MISC,
    BZ2_CAT_BIRTH,
    BZ2_CAT_BLANKETS_WRAPPERS,
    BZ2_CAT_BLOUSE_SHIRTS,
    BZ2_CAT_BODYSUITS_SLEEPSUITS_ROMPERS,
    BZ2_CAT_BOOKS_AUDIO_VIDEO,
    BZ2_CAT_BOUNCERS,
    BZ2_CAT_BREASTFEEDING_ACCESSORIES,
    BZ2_CAT_CAMERA_PHOTO_VIDEO,
    BZ2_CAT_CAR_SEATS,
    BZ2_CAT_CELEBRATIONS,
    BZ2_CAT_CHILDREN_AUDIO,
    BZ2_CAT_CHILDREN_BOOKS,
    BZ2_CAT_CHILDREN_CARE,
    BZ2_CAT_CHILDREN_CLOTHING,
    BZ2_CAT_CHILDREN_MAGAZINES,
    BZ2_CAT_CHILDREN_MULTIMEDIA,
    BZ2_CAT_CHILDREN_VIDEO,
    BZ2_CAT_CHRISTMAS,
    BZ2_CAT_CLOTHING_MEGAPACKS,
    BZ2_CAT_COSMETICS_BATHING,
    BZ2_CAT_COTS,
    BZ2_CAT_DINING,
    BZ2_CAT_DRESSES_SKIRTS,
    BZ2_CAT_EARLY_BABIES,
    BZ2_CAT_EASTER,
    BZ2_CAT_ELECTRONICS,
    BZ2_CAT_FACE_PAINTING,
    BZ2_CAT_FANCY_DRESS,
    BZ2_CAT_FANCY_DRESS_ACCESSORIES,
    BZ2_CAT_FOOD,
    BZ2_CAT_FOOTWEAR,
    BZ2_CAT_GIFTS,
    BZ2_CAT_HATS_MITTENS_SCARVES,
    BZ2_CAT_HOME_ACCESSORIES_DECORATIONS,
    BZ2_CAT_HOME_ANTIQUITIES,
    BZ2_CAT_HOME_APPLIANCES,
    BZ2_CAT_HOME_CARE_CLEANING,
    BZ2_CAT_HOME_CARPETS_RUGS,
    BZ2_CAT_HOME_COOKING_BAKING_WARE,
    BZ2_CAT_HOME_DINING,
    BZ2_CAT_HOME_FOOD_STORAGE,
    BZ2_CAT_HOME_FURNITURE,
    BZ2_CAT_HOME_LIGHTING,
    BZ2_CAT_HOME_LIVING,
    BZ2_CAT_HOME_TEXTILES,
    BZ2_CAT_JACKETS_COATS,
    BZ2_CAT_KIDS_PARTY,
    BZ2_CAT_KINDERGARDEN_SCHOOL,
    BZ2_CAT_MISC,
    BZ2_CAT_MISC_MOTHERHOOD,
    BZ2_CAT_MOTHER_CLOTHING,
    BZ2_CAT_MOTHERS_NOURISHMENT,
    BZ2_CAT_NAPPIES,
    BZ2_CAT_NOURISHMENT,
    BZ2_CAT_NURSERY,
    BZ2_CAT_NURSING_BRA,
    BZ2_CAT_OCCASION_WEAR,
    BZ2_CAT_OTHER_ELECTRONICS,
    BZ2_CAT_OUTFITS,
    BZ2_CAT_PARTY_CARNEVAL,
    BZ2_CAT_PC_GAMING,
    BZ2_CAT_PC_NOTEBOOKS,
    BZ2_CAT_PETS,
    BZ2_CAT_PHONES_TABLETS_EREADERS,
    BZ2_CAT_PRAMS,
    BZ2_CAT_PREGNANCY_CLOTHING,
    BZ2_CAT_PREGNANCY_MOTHERS,
    BZ2_CAT_SAFETY,
    BZ2_CAT_SHORTS_CROPS,
    BZ2_CAT_SLEEPING_BAGS,
    BZ2_CAT_SLEEPWEAR,
    BZ2_CAT_SNOWSUITS,
    BZ2_CAT_SOCKS_TIGHTS,
    BZ2_CAT_SPORT,
    BZ2_CAT_SWEATSHIRTS_JUMPERS_VESTS,
    BZ2_CAT_SWIMWEAR_DRESSING_GOWNS,
    BZ2_CAT_TOYS,
    BZ2_CAT_TROUSERS_JEANS_JOGGERS,
    BZ2_CAT_TSHIRTS_TOPS,
    BZ2_CAT_TWINS,
    BZ2_CAT_TWINS_GROUP,
    BZ2_CAT_TWINS_MISC,
    BZ2_CAT_UNDERWEAR,
    BZ2_CAT_WALKERS,
};
